export const RPC_URLS = {
    421614: "https://arbitrum-sepolia.infura.io/v3/" + process.env.REACT_APP_INFURA_KEY,
    11155420: "https://optimism-sepolia.infura.io/v3/" + process.env.REACT_APP_INFURA_KEY,
    42161: "https://arbitrum-mainnet.infura.io/v3/" + process.env.REACT_APP_INFURA_KEY,
    10: "https://optimism-mainnet.infura.io/v3/" + process.env.REACT_APP_INFURA_KEY,
    43114: "https://avalanche-mainnet.infura.io/v3/" + process.env.REACT_APP_INFURA_KEY,
    8453: "https://1rpc.io/base"
}